import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class SendRequestStrategy extends BaseSendMedicalNoteItemToPortalPopupStrategy {
    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = LocalPatientOperations.MedicalNote.Request_OnPortalRequestMessageChecked;

    public get isSignatureRequired(): boolean {
        return this.sharedItemCanBeSigned;
    }

    public get signableFile(): string {
        return this.portalPopupModel.fileUrl;
    }

    constructor(
        linkedItemType: PortalLinkedItemType.LabRequest | PortalLinkedItemType.ConsultationRequest,
        portalPopupModel: PortalPopupModel,
        signatureAcceptedCallback: () => void,
        signatureRejectedCallback: () => void = null,
        removeSignature: () => void = null
    ) {
        super(
            linkedItemType,
            LocalPatientOperations.MedicalNote.Request_PortalStatusRevoke,
            LocalPatientOperations.MedicalNote.Request_ClosePortalPopup,
            portalPopupModel,
            signatureAcceptedCallback,
            signatureRejectedCallback,
            removeSignature
        );
    }

    public onSendToPortalClick(
        subject: string,
        newMessage: string,
        includeDocument: boolean,
        _portalItemModel?: IPortalLinkedItemModel,
        priority?: SharedItemPriority,
        canPatientReplyWithMessage?: boolean
    ): void {
        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.Request_SendToPortal,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument,
                priority: priority,
                canPatientReplyWithMessage: canPatientReplyWithMessage
            }
        );
    }
}

export { SendRequestStrategy };
